import React, {type CSSProperties} from 'react';

import {
    AutosuggestListCaption,
} from '@pb/kit-component-autosuggest-v2';
import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';

import {
    ERROR_MESSAGE,
    NO_RESULTS_MESSAGE,
    UNCLEAR_QUERY_MESSAGE,
} from '../../constants';
import {PresetSuggestItem} from '../preset-suggest-item';

import type {SuggestionSections} from '../../types';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    query: string,
    isLoading: boolean,
    response: ServerResponse<SuggestionSections> | null,
    selectedSuggestions: string[],
};

const presetSuggestCaptionStyle: CSSProperties = {
    textTransform: 'capitalize',
    color: '#84919b',
    fontWeight: 400,
    backgroundColor: '#ffffff',
    borderColor: 'transparent',
};

export const PresetSuggestResults = ({
    id,
    query,
    isLoading,
    response,
    selectedSuggestions,
}: Props) => {
    const trimmedQuery = query.trim();
    const normalizedQuery = trimmedQuery.toLowerCase();

    if (trimmedQuery.length < 2) {
        return (
            <div id={id} className="pd-l">
                {UNCLEAR_QUERY_MESSAGE}
            </div>
        );
    }

    if (isLoading) {
        return (
            <div id={id} className="pd-l">
                <Group>
                    <Loading type="ICON" fast={true}/> Loading...
                </Group>
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-l">
                {ERROR_MESSAGE}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-l">
                {NO_RESULTS_MESSAGE}
            </div>
        );
    }

    if (!response?.data?.length) {
        return null;
    }

    return (
        <div id={id}>
            {response.data.map(section => (
                <React.Fragment key={section.title}>
                    <AutosuggestListCaption
                        style={presetSuggestCaptionStyle}>
                        {section.title}
                    </AutosuggestListCaption>
                    {section.suggestionItems.map(suggestion => (
                        <PresetSuggestItem
                            key={suggestion.id}
                            suggestion={suggestion}
                            normalizedQuery={normalizedQuery}
                            isSelected={selectedSuggestions.includes(suggestion.id)}
                        />
                    ))}
                </React.Fragment>
            ))}
        </div>
    );
};
